import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { trackPageView } from './utils/tracking'
import './assets/styles/main.css'

const app = createApp(App)
app.use(router)
app.use(store) // Add this line to inject the Vuex store
app.mount('#app')

// Set up navigation tracking for single-page app
router.afterEach((to) => {
  // Track page views in Matomo when routes change
  trackPageView(to.fullPath, to.meta.title || document.title)
})